import _ from 'lodash';
import React, { useContext } from 'react';
import {showDollarAmountWithDollar} from 'common/utils';
import {Button, Icon, Header} from 'semantic-ui-react';
import { ContentDispatch } from 'framework';
import {Contexts, Alert} from 'componentLibrary';
const { EligibleItemsContext,  RequestDetailsContext} = Contexts;

const GrandHeaderCard = ({
  noHeaderName,
  headerLink,
  name,
  id,
  guidance,
  itemType,
  grandTotal,
  actualGrandTotal,
  actualAllowedGrandTotal,
  allowAdd,
  showActivityModal,
  isLoaded,
  editable,
  hasEligibleChildren,
  headerContents,
  totalsInfo,
  entityDataPathIndx
}) => {
  const context = useContext(EligibleItemsContext);
  const rdContext = useContext(RequestDetailsContext);
  const actualGrandTotalTitle = _.get(rdContext, 'customizations.actualGrandTotalLabel', 'Actual grand total');
  const actualAllowedGrandtotalTitle = _.get(rdContext, 'customizations.actualAllowedGrandTotalLabel', 'Actual allowed grand total');
  const hideButtons = _.get(rdContext, 'customizations.hideButtons', false);
  const dataObject = _.get(context, 'dataObject', {});
  const isPaymentHiring = _.get(totalsInfo, 'isPaymentHiring');
  const showDiscrepancyAlert =
  _.get(totalsInfo, 'fedResourcesRequestedRounded', 0) !==
  _.get(totalsInfo, 'fedResourcesRequestedUnrounded', 0);
  let showActualGrandTotal = false;
  if (_.isNumber(actualGrandTotal)) {
    showActualGrandTotal = true;
  }
  let showActualAllowedGrandTotal = false;
  if (_.isNumber(actualAllowedGrandTotal)) {
    showActualAllowedGrandTotal = true;
  }

  return (
    <React.Fragment>
      <div>
        {!noHeaderName && (
          <Header id={id} as={'h2'}>
            {headerLink ? <a href={`/subGrant/${name}`} target="_blank" alt="View subgrant">{name}</a> : name}
          </Header>
        )}
        {_.map(headerContents, (entry) => {
          return <ContentDispatch config={entry} key={entry.title} dataObject={dataObject} entityDataPathIndx={entityDataPathIndx} />;
        })}
        <p className="margin-bottom30">{guidance}</p>
        <div style={{display: 'flow-root'}}>
          {isLoaded && editable && hasEligibleChildren && !hideButtons && allowAdd &&(
            <Button
              className="ui large left floated button"
              primary
              as="a"
              href="#"
              onClick={() => showActivityModal()}
            >
              <Icon name="plus" fitted /> {itemType}
            </Button>
          )}
          <p className="apph3 grand-total margin-bottom30 margin-top30">
            <strong>
            {<span title='grant total'>{isPaymentHiring ? 'Grand total federal resources requested' : 
              'Grand total'}: {showDollarAmountWithDollar(grandTotal) }</span>}
            {
              showActualGrandTotal && (
                <span> | </span> 
              )
            }
            {
              showActualGrandTotal && (
                <span className='blue' title={actualGrandTotalTitle}>{actualGrandTotalTitle}: {showDollarAmountWithDollar(actualGrandTotal)}</span> 
              )
            }
            {
              showActualAllowedGrandTotal && (
                <span> | </span> 
              )
            }
            {
              showActualAllowedGrandTotal && (
                <span className='blue' title={actualAllowedGrandtotalTitle}>{actualAllowedGrandtotalTitle}: {showDollarAmountWithDollar(actualAllowedGrandTotal)}</span> 
              )
            }
            </strong>
          </p>
          {showDiscrepancyAlert && <div style={{'margin-top': -25}}>
            <Alert
              size="mini"
              header="Grand total federal resources requested"
              type="info"
              dismissable={false}
            >
              Due to rounding resulting from cost share calculations, the grand total
              federal resources requested may not equal the sum of the positions below.
            </Alert>
          </div>}
        </div>
      </div>
    </React.Fragment>
  );
};

export {GrandHeaderCard};
